module.exports = __webpack_public_path__ + "img/fruit-oranges-190x100.74d803bc.jpg";